
import type { PropType } from 'vue'
import { defineComponent, computed } from 'vue'
import { format } from 'date-fns'

import type { DateTimeString } from '@/types'

export default defineComponent({
  name: 'SidebarTime',
  inheritAttrs: false,
  props: {
    value: {
      type: String as PropType<DateTimeString>,
      required: true,
    },
  },
  setup(props) {
    const formatted = computed(() =>
      format(new Date(props.value), "yyyy-MM-dd' 'HH:mm")
    )
    return { formatted }
  },
})
